import Axios from "axios";
import loginService from "./LoginService";

let headers = {
  Accept: "application/json,image/jpeg"
};

const backApi = Axios.create({
  baseURL: process.env.VUE_APP_BACK_API,
  timeout: 99999,
  headers: headers,
  withCredentials: true
});

const bffApi = Axios.create({
  baseURL: process.env.VUE_APP_BFF,
  timeout: 99999,
  headers: headers,
  withCredentials: true
});

backApi.interceptors.response.use(
  response => {
    return response;
  },
  handleError()
);

function handleError() {
  return async error => {
    if (error.response.status == 401) {
      await loginService.logout();
      return Promise.reject(error.response);
    } else if(error.response.status == 403) {
      let errorResponse = {
        message: 'Você não tem acesso',
        status: error.response.status
      }
      return Promise.reject(errorResponse);
    } else if(error.response.status == 500) {
      let errorResponse = {
        message: 'Erro desconhecido do servidor',
        status: error.response.status
      }
      return Promise.reject(errorResponse);
    } else {
      let data = error.response.data;
      if (data instanceof Blob && error.response.status == 400) {
        const dataTxt = await data.text()
        data = JSON.parse(dataTxt);
      }
      let errorResponse = {
        message: data.message,
        code: data.erroCode,
        status: error.response.status
      }
      return Promise.reject(errorResponse);
    }
  }
}

export default {
  backApi,
  bffApi
};
